import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Notification } from "../../../components/GenericActions";
import FeeService from "./fee.service";

const initialState = {
  feeData: null,
  allFeeData: null,

  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const createFee = createAsyncThunk(
  "fee/create",
  async ({ finalData, onCreateSuccess }, thunkAPI) => {
    try {
      const response = await FeeService.createFeeData(finalData);
      if (response.succeeded === true) {
        if (onCreateSuccess) {
          onCreateSuccess();
        }
        onCreateSuccess();
        Notification(response.message, response.succeeded);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllFee = createAsyncThunk(
  "fee/getAll",
  async (finalData, thunkAPI) => {
    try {
      return await FeeService.getAllFeeData(finalData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getFee = createAsyncThunk(
  "fee/get",
  async (finalData, thunkAPI) => {
    try {
      return await FeeService.getFeeData(finalData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      // Notification(message, false);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateFee = createAsyncThunk(
  "fee/update",
  async ({ finalData, onCreateSuccess }, thunkAPI) => {
    try {
      const response = await FeeService.updateFeeData(finalData);
      if (response.succeeded === true) {
        if (onCreateSuccess) {
          onCreateSuccess();
        }
        // callBackFunc();
        Notification(response.message, response.succeeded);
      }
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      if (error?.response?.status != 401) {
        Notification(message, false);
      }
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const feeSlice = createSlice({
  name: "fee",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createFee.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createFee.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.feeData = action.payload;
        // let a = state.getAllUser;
        //     a.push(action.payload);
      })
      .addCase(createFee.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })

      .addCase(getFee.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFee.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.feeData = action.payload.data;
      })
      .addCase(getFee.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })
      .addCase(updateFee.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(updateFee.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.feeData = action.payload;
      })
      .addCase(updateFee.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      })
      .addCase(getAllFee.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })
      .addCase(getAllFee.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.allFeeData = action.payload.data;
      })
      .addCase(getAllFee.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      });
  },
});
export const { clearData } = feeSlice.actions;

export default feeSlice.reducer;
